import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import AppWrapper from './msal/AppWrapper';
import { msalConfig } from './msal/MsalConfig';

import './styles.css';

var WebFontConfig = {
    google: { families: ['Roboto'] },
};
(function () {
    var wf = document.createElement('script');
    wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wf, s);
})();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const msalInstance = new PublicClientApplication(msalConfig);

root.render(
    <div>
        <MsalProvider instance={msalInstance}>
            <AppWrapper />
        </MsalProvider>
    </div>
);